export default __webpack_public_path__ + "static/tab1Img-d046d7f58c075a244c95a348409961cc.png";